import { Game } from '@denishussar/html5-game-engine';
import { SoundConstants } from './game/Constants/Sounds';
import { GameInstance } from './game/GameInstance';
import Rollbar from 'rollbar';

declare var require;
require('../fonts/fonts.css');
const gameCfg = require('../game-config.json');
const version = require('./../package.json').version;

/* CUT-FROM-DEV-START */
{
    // Bugtracker init
    const rollbarConfig = {
        accessToken: 'f026ac8d8d0a40fd866ce4619bf46774', //todo: setup from env
        captureUncaught: true,
        captureUnhandledRejections: true,
        payload: {
            environment: 'qa-preview',
            client: {
                javascript: {
                    code_version: version,
                },
            },
        },
    };
    /* CUT-FROM-QA-BUILD-START */
    {
        rollbarConfig.payload.environment = 'production';
    }
    /* CUT-FROM-QA-BUILD-END */
    new Rollbar(rollbarConfig);
    console.log('Rollbar init in mode:', rollbarConfig.payload.environment);
}

/* CUT-FROM-DEV-END */

export enum IReleasePlatform {
    standalone = 'standalone',
    crazygames = 'crazygames',
}

export interface GameOptions {
    releasePlatform: IReleasePlatform;
    containerElementId?: string;
}

export class Games {
    public static startGame(options: GameOptions): Game {
        return new Game({
            main: GameInstance,
            version: version,
            sounds: [
                {
                    id: SoundConstants.ACTIVE_BUTTON,
                    path: '/sounds/active_button.mp3',
                },
                {
                    id: SoundConstants.BOOSTER_BRUSH,
                    path: '/sounds/booster_brush.mp3',
                },
                {
                    id: SoundConstants.BOOSTER_NEEDLE,
                    path: '/sounds/booster_needle.mp3',
                },
                {
                    id: SoundConstants.BOOSTER_BUCKET,
                    path: '/sounds/booster_needle.mp3',
                },
                {
                    id: SoundConstants.OPEN_DESCRIPTION,
                    path: '/sounds/open_description.mp3',
                },
                {
                    id: SoundConstants.THROW_THE_PAGE,
                    path: '/sounds/throw_the_page.mp3',
                },
                {
                    id: SoundConstants.UNACTIVE_BUTTON,
                    path: '/sounds/unactive_button.mp3',
                },
                {
                    id: SoundConstants.WIN_SCREEN,
                    path: '/sounds/win_screen.mp3',
                },
                {
                    id: SoundConstants.YARN_IN_THE_FOREST,
                    path: '/sounds/yarn_in_the_forest.mp3',
                },
            ],
            assetsRoot: gameCfg.resourcesRoot,
            elementId: options.containerElementId || 'gamePlace',
            noWebGL: false,
            backgroundColor: 0x212b44,
            clearBeforeRender: true,
            transparent: false,
            fps: 60,
            gameId: gameCfg.gameId,
            orientations: [],
            antialias: false,
            options: options,
        });
    }
}
